import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {GridColDef} from "@mui/x-data-grid";
import React, {useMemo, useState} from "react";
import {UserGroupDto} from "../../../../../common/apis/usergroup/UserGroupDto";
import Grid from "../../../../../components/dialogs/Grid";
import DataGridContainer from "../../../../../components/grid/DataGridContainer";
import ExtGridWrapper from "../../../../../components/grid/ExtGridWrapper";
import {ActionButtonType, EnabledPolicy, GridAction} from "../../../../../components/grid/GridAction";
import SectionHeader from "../../../../../components/section/SectionHeader";
import {PersistentStateId} from "../../../../../store/common/Grid";
import {t} from "../../../../../store/localization/TranslMessasge";
import UserGroupMemberDeleteDialog from "../../usergroups/membership/UserGroupMemberDeleteDialog";
import {UserGroupsTranslationKey} from "../../usergroups/UserGroupsTranslationKey";
import {useFindUserGroupsByLoginQuery} from "../UserQuery";
import {UsersTranslationKey} from "../UsersTranslationKey";
import UserGroupMembershipAddDialog from "./UserGroupMembershipAddDialog";
import {UserGroupMembershipPanelButtonId} from "./UserGroupMembershipPanelButtonId";

interface UserGroupMembershipPanelProps {
    login: string;
}

export default function UserGroupMembershipPanel({login}: Readonly<UserGroupMembershipPanelProps>) {
    const userGroupsQuery = useFindUserGroupsByLoginQuery(login);
    const userGroups: UserGroupDto[] = userGroupsQuery.data ?? [];

    const [selectedGroupId, setSelectedGroupId] = useState<string | undefined>();
    const [addDialogOpen, setAddDialogOpen] = useState(false);
    const [removeDialogOpen, setRemoveDialogOpen] = useState(false);

    const columns: GridColDef<UserGroupDto>[] = useMemo(() => [
        {field: 'name', headerName: t(UserGroupsTranslationKey.NAME), width: 300},
        {field: 'description', headerName: t(UserGroupsTranslationKey.DESCRIPTION), width: 400},
    ], []);

    return (
            <Grid container>
                <Grid item xs={12}>
                    <SectionHeader title={t(UsersTranslationKey.USER_GROUPS)}/>
                </Grid>
                <Grid item xs={12}>
                    <DataGridContainer height={"8em"}>
                        <ExtGridWrapper
                                columns={columns}
                                rows={userGroups}
                                rowCount={userGroups.length}
                                getRowId={row => row.id}
                                autoHeight={false}
                                actions={[
                                    GridAction.buttonBuilder(UserGroupMembershipPanelButtonId.ADD_USER_GROUP, ActionButtonType.IMMEDIATE,
                                            t(UserGroupsTranslationKey.ADD_MEMBERSHIP), <AddIcon/>)
                                            .enabledPolicy(EnabledPolicy.ALWAYS)
                                            .onClick(() => setAddDialogOpen(true))
                                            .build(),
                                    GridAction.buttonBuilder(UserGroupMembershipPanelButtonId.REMOVE_USER_GROUP, ActionButtonType.IMMEDIATE,
                                            t(UserGroupsTranslationKey.REMOVE_MEMBERSHIP), <DeleteIcon/>)
                                            .enabledPolicy(EnabledPolicy.WHEN_EXACTLY_ONE_SELECTED)
                                            .onClick((selectedRowIds) => {
                                                setSelectedGroupId(selectedRowIds[0] as string);
                                                setRemoveDialogOpen(true);
                                            })
                                            .build(),
                                ]}
                                peristentStateId={PersistentStateId.USER_DETAIL_PAGE_USER_GROUPS_GRID}
                                resourceId={"userGroups"}
                        />
                    </DataGridContainer>
                </Grid>
                {addDialogOpen &&
                        <UserGroupMembershipAddDialog
                                open={addDialogOpen}
                                userLogin={login}
                                onClose={() => setAddDialogOpen(false)}/>
                }
                {selectedGroupId &&
                        <UserGroupMemberDeleteDialog
                                open={removeDialogOpen}
                                groupId={selectedGroupId}
                                userLogin={login}
                                title={t(UserGroupsTranslationKey.REMOVE_GROUP_MEMBERSHIP_QUESTION_MARK)}
                                onClose={() => setRemoveDialogOpen(false)}/>
                }
            </Grid>
    );
}
